import { instance, errorService } from '@/services/api'
import { templateAPIs } from '@/services/authConstantsV1'
import Vue from 'vue'
import _ from 'lodash'
import DynamicTable from '@/components/DynamicComponents/Templates/Grid'
import { showNotification } from '@/services/calculate'
import { socketEvents } from '@/services/config'
import InteriorGrouping from '@/components/DynamicComponents/Templates/InteriorGrouping'

export default {
  components: {
    DynamicTable,
    'interior-grouping': InteriorGrouping,
  },
  props: [
    'templateData',
    'screenIndentifier',
    'dropdownData',
    'tableId',
    'screen_Name',
    'projectModule',
    'type',
    'viewOnly',
    'columnSettings',
  ],
  data() {
    return {
      dropdownInfo: this.dropdownData,
      columnDefs: [],
      templateInfo: this.templateData,
      firstLevelActive: 0,
      secondLevelActive: 0,
      loader: false,
      allPannels: [],
      loaderLevel0: false,
      loaderLevel1: false,
      loaderLevel2: false,
      constructionInfoData: {
        screenName: 'Interior Info',
        id: '',
        data: {},
      },
      showSecondLevelTab: false,
      create: new Vue(),
      tenantId: undefined,
      tabIndex: 0,
      visible: false,
      role: null,
      emptyImage: process.env.BASE_URL + 'resources/images/empty.png',
      tenantArea: undefined,
      tenantPerimeter: undefined,
      buildingData: this.templateData,
      activeIndex: 0,
      indexData: undefined,
      tenantApproachId: undefined,
      fieldName: null,
      groupings: [],
      isSequence: false,
      tabKey: undefined,
    }
  },
  beforeMount() {
    this.loadingConfig()
  },
  created() {},
  mounted() {
    this.$socketHub.$on('message-received', this.messageRecieved)
    const user = JSON.parse(localStorage.getItem('userDetails'))
    this.role = user.role
    this.getInteriorInfo()
  },
  beforeDestroy() {
    this.$socketHub.$off('message-received')
  },
  methods: {
    loadingConfig() {
      this.columnDefs = [
        {
          rowDrag: true,
          headerName: '',
          field: 'display',
          floatingFilter: false,
          width: 3,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          sortable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          floatingFilter: false,
          width: 5,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isLocked',
          headerTooltip: 'Locked',
          width: 30,
          editable: false,
          cellRenderer: 'lockRenderer',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            viewOnly: this.viewOnly,
          },
          floatingFilter: false,
          resizable: false,
          suppressSizeToFit: true,
          hide: true,
          pinned: 'left',
          menuTabs: [],
        },
        {
          headerName: '',
          field: 'isValidTakeoff',
          width: 5,
          hide: true,
          floatingFilter: false,
          suppressSizeToFit: true,
          resizable: false,
          editable: false,
        },
        {
          headerName: 'Contract',
          field: 'contract',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Contract',
          suppressSizeToFit: true,
          resizable: true,
        },
        {
          headerName: 'Category Code',
          field: 'categoryCode',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
          },
          width: 150,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Category Code',
          suppressSizeToFit: true,
          resizable: true,
        },
        {
          headerName: 'Additional Description',
          field: 'additionalDescription',
          headerClass: 'header-center',
          cellStyle: { textAlign: 'center' },
          cellEditor: 'textEditor',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Additional Description',
          },
          width: 150,
          headerTooltip: 'Additional Description',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Takeoff Description',
          field: 'takeoff',
          cellEditor: 'takeoffSelectEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'takeoff',
            screen: 'Template',
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Takeoff',
          resizable: true,
          width: 420,
        },
        {
          headerName: 'Calculation',
          field: 'calculation',
          cellEditor: 'calculationEditor',
          cellStyle: { textAlign: 'left' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            name: 'calculation',
            dropdownData: this.dropdownInfo.calculation,
          },
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Calculation',
          resizable: true,
          sortable: false,
          floatingFilter: false,
          width: 100,
        },
        {
          headerName: 'Quantity',
          field: 'quantity',
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            placeholder: 'Quantity',
            precision: 0,
            min: 0,
            max: 999999999,
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Quantity',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Unit',
          field: 'unit',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
          },
          width: 100,
          cellRenderer: 'toolTipRenderer',
          headerTooltip: 'Unit',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Unit Cost',
          field: 'unitCost',
          cellRenderer: 'costPriceCellRenderer',
          cellStyle: { textAlign: 'right' },
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'string',
            placeholder: 'Unit Cost',
            precision: 2,
            min: 0,
          },
          width: 120,
          headerTooltip: 'Unit Cost',
          resizable: true,
          suppressSizeToFit: true,
        },
        {
          headerName: 'Condition Factor',
          field: 'conditionFactor',
          headerClass: 'header-center',
          cellEditor: 'selectEditor',
          wrapText: false,
          filter: 'customFilter',
          cellRendererParams: {
            type: 'dynamicTable',
            dataType: 'int',
            dropdownName: 'conditionFactor',
            dropdownData: this.dropdownData.condition_factor,
            name: 'conditionFactor',
            width: '350px !important',
            editable: true,
          },
          width: 150,
          headerTooltip: 'Condition Factor',
          suppressSizeToFit: true,
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Multiplier',
          field: 'multiplier',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'toolTipRenderer',
          cellRendererParams: {
            name: 'multiplier',
            type: 'dynamicTable',
            dataType: 'int',
            precision: 3,
          },
          width: 100,
          headerTooltip: 'Multiplier',
          suppressSizeToFit: true,
        },
        {
          headerName: 'Action',
          field: 'action',
          sortable: false,
          editable: false,
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellRendererParams: {
            screenType: 'Template',
          },
          floatingFilter: false,
          width: 60,
          resizable: false,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          pinned: 'right',
          hide: this.viewOnly,
          menuTabs: [],
        },
      ]
    },

    callback(val) {
      this.fieldName = null
      let indexData = null
      switch (this.templateInfo.structureProfileId) {
        case 1:
          this.firstLevelActive = val
          this.secondLevelActive = 0
          indexData = _.findIndex(this.allPannels, data => {
            return data.id === val
          })
          this.tabIndex = indexData
          this.getDetails(val, indexData, 'loaderLevel0')
          break
        case 2:
          this.firstLevelActive = val
          this.secondLevelActive = 0
          indexData = _.findIndex(this.allPannels, data => {
            return data.id === val
          })
          this.tabIndex = indexData
          this.getDetails(val, indexData, 'loaderLevel0')
          break
        case 3:
          if (this.showSecondLevelTab) {
            this.firstLevelActive = val
            this.secondLevelActive = val
            indexData = _.findIndex(this.allPannels, data => {
              return data.id === val
            })
            this.tabIndex = indexData
            this.tenantId = this.allPannels[this.tabIndex]['tenantId']
              ? this.allPannels[this.tabIndex]['tenantId']
              : undefined
            this.tenantArea = this.allPannels[this.tabIndex]['area']
              ? this.allPannels[this.tabIndex]['area']
              : undefined
            this.tenantPerimeter = this.allPannels[this.tabIndex]['perimeter']
              ? this.allPannels[this.tabIndex]['perimeter']
              : undefined
            this.getDetails(val, indexData, 'loaderLevel1')
            break
          } else {
            this.firstLevelActive = val
            this.secondLevelActive = 0
            indexData = _.findIndex(this.allPannels, data => {
              return data.id === val
            })
            this.tabIndex = indexData
            if (indexData === 0) {
              this.tenantId = this.allPannels[this.tabIndex]['tenantId']
                ? this.allPannels[this.tabIndex]['tenantId']
                : undefined
              this.tenantArea = this.allPannels[this.tabIndex]['area']
                ? this.allPannels[this.tabIndex]['area']
                : undefined
              this.tenantPerimeter = this.allPannels[this.tabIndex]['perimeter']
                ? this.allPannels[this.tabIndex]['perimeter']
                : undefined
            }
            this.getDetails(val, indexData, 'loaderLevel0')
          }
      }
    },

    getInteriorInfo() {
      this.loader = true
      const url = templateAPIs.interiorInfo.getInteriorInfoDetails(
        this.$route.params.id,
      )
      instance
        .get(url)
        .then(res => {
          this.loader = false
          const result = _.get(res.data, 'result', [])
          if (result.length > 0) {
            this.tenantApproachId = _.get(
              result[0],
              'tenantApproachId',
              undefined,
            )
          }
          switch (this.templateInfo.structureProfileId) {
            case 1:
              this.allPannels = []
              _.get(res.data, 'result', []).forEach(element => {
                if (!element.tenantName) {
                  element.tenantName = 'Tenant'
                }
                this.allPannels.push(element)
                if (
                  element.interiorGroupings &&
                  element.interiorGroupings.length > 0
                ) {
                  element.interiorGroupings.forEach(element => {
                    this.allPannels.push(element)
                  })
                }
              })
              this.firstLevelActive = this.allPannels[0].id
              this.callback(this.allPannels[0].id)
              this.showSecondLevelTab = false
              break
            case 2:
            case 3:
              if (
                this.tenantApproachId === 2 ||
                this.templateInfo.structureProfileId === 2
              ) {
                this.allPannels = []
                _.get(res.data, 'result', []).forEach(element => {
                  this.allPannels.push(element)
                  if (element.interiorGroupings.length > 0) {
                    element.interiorGroupings.forEach(element => {
                      this.allPannels.push(element)
                    })
                  }
                })
                this.firstLevelActive = this.allPannels[0].id
                this.callback(this.firstLevelActive)
                this.showSecondLevelTab = false
                this.tenantId = this.allPannels[0].tenantId
                  ? this.allPannels[0].tenantId
                  : undefined
                this.tenantArea = this.allPannels[0].area
                  ? this.allPannels[0].area
                  : undefined
                this.tenantPerimeter = this.allPannels[0].perimeter
                  ? this.allPannels[0].perimeter
                  : undefined
              } else if (this.tenantApproachId) {
                this.showSecondLevelTab = true
                this.allPannels = _.get(res.data, 'result', [])
                this.allPannels.forEach(element => {
                  if (this.tenantApproachId === 1) {
                    Object.assign(element, { isTenantValid: true })
                  }
                })
                if (this.isSequence) {
                  this.secondLevelActive = this.firstLevelActive
                  this.callback(this.firstLevelActive)
                } else {
                  this.firstLevelActive = this.allPannels[0].id
                  this.secondLevelActive = this.allPannels[0].id
                  this.tenantId = this.allPannels[0]['tenantId']
                    ? this.allPannels[0]['tenantId']
                    : undefined
                  this.tenantArea = this.allPannels[0]['area']
                    ? this.allPannels[0]['area']
                    : undefined
                  this.tenantPerimeter = this.allPannels[0]['perimeter']
                    ? this.allPannels[0]['perimeter']
                    : undefined
                  this.callback(this.allPannels[0].id)
                }
              }
              break
            default:
          }
          this.isSequence = false
        })
        .catch(err => {
          this.loader = false
          errorService(err)
        })
    },

    getDetails(id, index, loaderName) {
      this[loaderName] = true
      const data = [...this.allPannels]
      const url = templateAPIs.interiorInfo.getTakeoffs(
        this.$route.params.id,
        id,
      )
      instance
        .get(url)
        .then(res => {
          this[loaderName] = false
          const takeoffs = _.get(res.data, 'result', [])
          takeoffs.forEach(element => {
            if (element.categoryCode) {
              element.categoryCode = Number(element.categoryCode)
            }
          })
          const isValid = takeoffs.some(i => i.isLocked)
          if (isValid) {
            const index = this.columnDefs.findIndex(
              i => i.field === 'isLocked',
            )
            this.columnDefs[index].hide = false
          }
          if (this.firstLevelActive === id) {
            data[index].takeoffs = [...takeoffs]
            if (this.tenantApproachId === 1) {
              data[index].isTenantValid = !takeoffs.some(
                i =>
                  typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
              )
            }
            this.allPannels = [...data]
          } else if (this.secondLevelActive === id) {
            const indexParent = _.findIndex(this.allPannels, value => {
              return value.id === this.firstLevelActive
            })
            const indexChild = _.findIndex(
              this.allPannels[indexParent].interiorGroupings,
              value => {
                return value.id === id
              },
            )
            data[indexParent]['interiorGroupings'][indexChild].takeoffs = [
              ...takeoffs,
            ]
            this.allPannels = [...data]
          }
          this.loader = false
        })
        .catch(err => {
          errorService(err)
          this[loaderName] = false
          this.loader = false
        })
    },

    secondLevel(val) {
      this.fieldName = null
      let indexData = null
      if (this.firstLevelActive === val) {
        indexData = _.findIndex(this.allPannels, data => {
          return data.id === val
        })
        this.secondLevelActive = val
        this.getDetails(val, indexData, 'loaderLevel1')
      } else {
        indexData = _.findIndex(
          this.allPannels[this.tabIndex].interiorGroupings,
          data => {
            return data.id === val
          },
        )
        this.secondLevelActive = val
        this.getDetails(val, indexData, 'loaderLevel2')
      }
    },

    addNewData(event, id) {
      this.constructionInfoData['id'] = id
      this.create.$emit('addRecord')
      event.stopPropagation()
    },

    // Update Basic Details
    updateBasicData(data) {
      const newData = [...this.allPannels]
      let indexData = null
      let indexParent = null
      const keys = Object.keys(data)
      if (data.id === this.firstLevelActive) {
        indexData = _.findIndex(this.allPannels, value => {
          return value.id === data.id
        })
        keys.forEach(element => {
          if (element === 'area' || element === 'perimeter') {
            this.fieldName = element
            newData[indexData][element] = Number(data[element])
            if (data.fieldInfo === 'Tenant Perimeter') {
              this.tenantPerimeter = Number(data.perimeter)
            }
          } else {
            newData[indexData][element] = data[element]
          }
        })
        this.allPannels = [...newData]
      } else {
        if (data.id === this.secondLevelActive) {
          indexParent = _.findIndex(this.allPannels, value => {
            return value.id === this.firstLevelActive
          })
          indexData = _.findIndex(
            this.allPannels[indexParent]['interiorGroupings'],
            value => {
              return value.id === data.id
            },
          )
          keys.forEach(element => {
            if (element === 'area' || element === 'perimeter') {
              this.fieldName = element
              newData[indexParent]['interiorGroupings'][indexData][
                element
              ] = Number(data[element])
            } else {
              newData[indexParent]['interiorGroupings'][indexData][element] =
                data[element]
            }
          })
        }
        this.allPannels = [...newData]
      }
    },

    // Update take off details with conditional check
    updateBuildingFacts(data) {
      const newData = [...this.allPannels]
      // First Level update building fact details
      if (data.rowId === this.firstLevelActive) {
        this.activeIndex = _.findIndex(this.allPannels, value => {
          return value.id === this.firstLevelActive
        })
        this.allPannels[this.activeIndex].takeoffs = data.data
        if (this.tenantApproachId === 1) {
          this.allPannels[this.activeIndex].isTenantValid = data.isValidTakeoff
          if (!data.isValidTakeoff) {
            this.allPannels[this.activeIndex].isValidTakeoff =
              data.isValidTakeoff
          } else {
            this.allPannels[this.activeIndex].isValidTakeoff = !newData[
              this.activeIndex
            ].interiorGroupings.some(
              i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
            )
          }
        } else {
          this.allPannels[this.activeIndex].isValidTakeoff =
            data.isValidTakeoff
        }
        this.allPannels = [...newData]
      } else {
        // second Level update building fact details
        this.activeIndex = _.findIndex(this.allPannels, value => {
          return value.id === this.firstLevelActive
        })
        if (data.rowId === this.secondLevelActive) {
          this.indexData = _.findIndex(
            this.allPannels[this.activeIndex].interiorGroupings,
            value => {
              return value.id === data.rowId
            },
          )
          newData[this.activeIndex]['interiorGroupings'][
            this.indexData
          ].takeoffs = data.data
          newData[this.activeIndex].interiorGroupings[
            this.indexData
          ].isValidTakeoff = data.isValidTakeoff
        }
        if (this.tenantApproachId === 1) {
          const groupings = newData[this.activeIndex].interiorGroupings
          newData[this.activeIndex].isValidTakeoff = !groupings.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (newData[this.activeIndex].isValidTakeoff) {
            newData[this.activeIndex].isValidTakeoff =
              newData[this.activeIndex].isTenantValid
          }
        }
        this.allPannels = [...newData]
      }
    },

    showGrouping() {
      this.visible = true
      this.groupings = []
      if (
        this.templateInfo.structureProfileId !== 3 ||
        this.tenantApproachId === 2
      ) {
        this.groupings = this.allPannels[0].interiorGroupings
      } else {
        this.groupings = this.allPannels[this.tabIndex].interiorGroupings
      }
    },

    onClose(record, ids, type, key) {
      let index
      switch (type) {
        case 'add':
          this.isSequence = false
          if (
            this.templateInfo.structureProfileId !== 3 ||
            this.tenantApproachId === 2
          ) {
            this.allPannels.push(record)
            this.allPannels[0].interiorGroupings.push(record)
          } else {
            this.allPannels[this.tabIndex].interiorGroupings.push(record)
          }
          break
        case 'update':
          this.isSequence = false
          this.fieldName = key
          if (key === 'area' || key === 'perimeter') {
            this.loader = true
          }
          if (
            this.templateInfo.structureProfileId !== 3 ||
            this.tenantApproachId === 2
          ) {
            const index = this.allPannels.findIndex(i => i.id === record.id)
            this.tabKey = this.allPannels[index].id
            this.allPannels[index].label = record.label
            this.allPannels[index].value = record.value
            this.allPannels[index].area = record.area
            this.allPannels[index].perimeter = record.perimeter
          } else {
            const index = this.allPannels[
              this.tabIndex
            ].interiorGroupings.findIndex(i => i.id === record.id)
            this.tabKey = this.allPannels[this.tabIndex].interiorGroupings[
              index
            ].id
            this.allPannels[this.tabIndex].interiorGroupings[index].label =
              record.label
            this.allPannels[this.tabIndex].interiorGroupings[index].value =
              record.value

            this.allPannels[this.tabIndex].interiorGroupings[index].area =
              record.area
            this.allPannels[this.tabIndex].interiorGroupings[index].perimeter =
              record.perimeter
          }
          break
        case 'delete':
          let isDeleted = false
          this.isSequence = false
          ids.forEach(element => {
            if (
              this.templateInfo.structureProfileId !== 3 ||
              this.tenantApproachId === 2
            ) {
              const index = this.allPannels.findIndex(i => i.id === element.id)
              this.allPannels.splice(index, 1)
              if (this.allPannels[0].interiorGroupings.length > 0) {
                const groupIndex = this.allPannels[0].interiorGroupings.findIndex(
                  i => i.id === element.id,
                )
                this.allPannels[0].interiorGroupings.splice(groupIndex, 1)
              }
              isDeleted = ids.some(i => i.id === this.firstLevelActive)
              if (
                this.firstLevelActive !== this.allPannels[0].id &&
                isDeleted
              ) {
                this.callback(this.allPannels[0].id)
              }
            } else {
              const index = this.allPannels[
                this.tabIndex
              ].interiorGroupings.findIndex(i => i.id === element.id)
              this.allPannels[this.tabIndex].interiorGroupings.splice(index, 1)
              isDeleted = ids.some(i => i.id === this.secondLevelActive)
              if (
                this.secondLevelActive !== this.allPannels[this.tabIndex].id &&
                isDeleted
              ) {
                this.callback(this.allPannels[this.tabIndex].id)
              }
            }
          })
          break
        case 'sequence':
          this.loader = true
          this.isSequence = true
          this.getInteriorInfo()
          break
        case 'error':
          this.isSequence = false
          if (
            this.templateInfo.structureProfileId !== 3 ||
            this.tenantApproachId === 2
          ) {
            index = this.allPannels[0].interiorGroupings.findIndex(
              i => i.id === record.id,
            )
            this.allPannels[0].interiorGroupings[index].label = record.label
            this.allPannels[0].interiorGroupings[index].value = record.value
          } else {
            index = this.allPannels[this.tabIndex].interiorGroupings.findIndex(
              i => i.id === record.id,
            )
            this.allPannels[this.tabIndex].interiorGroupings[index].label =
              record.label
            this.allPannels[this.tabIndex].interiorGroupings[index].value =
              record.value
          }
          break
        default:
          this.visible = false
          break
      }
    },

    updateColumnSettings(request) {
      this.$emit('updateColumnSettings', request)
    },

    checkValidTab(id, isValid) {
      const newData = [...this.allPannels]
      if (id === this.firstLevelActive) {
        this.activeIndex = _.findIndex(this.allPannels, value => {
          return value.id === this.firstLevelActive
        })
        if (this.tenantApproachId === 1) {
          this.allPannels[this.activeIndex].isTenantValid = isValid
          if (!isValid) {
            this.allPannels[this.activeIndex].isValidTakeoff = isValid
          } else {
            this.allPannels[this.activeIndex].isValidTakeoff = !newData[
              this.activeIndex
            ].interiorGroupings.some(
              i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
            )
          }
        } else {
          this.allPannels[this.activeIndex].isValidTakeoff = isValid
        }
        this.allPannels = [...newData]
      } else {
        this.activeIndex = _.findIndex(this.allPannels, value => {
          return value.id === this.firstLevelActive
        })
        if (id === this.secondLevelActive) {
          this.indexData = _.findIndex(
            this.allPannels[this.activeIndex].interiorGroupings,
            value => {
              return value.id === id
            },
          )
          newData[this.activeIndex].interiorGroupings[
            this.indexData
          ].isValidTakeoff = isValid
        }
        if (this.tenantApproachId === 1) {
          const groupings = newData[this.activeIndex].interiorGroupings
          newData[this.activeIndex].isValidTakeoff = !groupings.some(
            i => typeof i.isValidTakeoff !== 'undefined' && !i.isValidTakeoff,
          )
          if (newData[this.activeIndex].isValidTakeoff) {
            newData[this.activeIndex].isValidTakeoff =
              newData[this.activeIndex].isTenantValid
          }
        }
        this.allPannels = [...newData]
      }
    },

    messageRecieved(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.templateSideBarUpdated) {
        this.$root.$emit('templateSideBarUpdated', message)
        this.loader = false
        if (this.visible) {
          if (this.fieldName === 'area' || this.fieldName === 'perimeter') {
            if (
              this.templateInfo.structureProfileId === 3 &&
              this.tenantApproachId === 1
            ) {
              if (this.tabKey === this.secondLevelActive) {
                this.secondLevel(this.secondLevelActive)
              }
            } else {
              if (this.tabKey === this.firstLevelActive) {
                this.callback(this.firstLevelActive)
              }
            }
          }
          this.tabKey = undefined
        } else {
          if (this.fieldName === 'area' || this.fieldName === 'perimeter') {
            if (
              this.templateInfo.structureProfileId === 3 &&
              this.tenantApproachId === 1
            ) {
              this.secondLevel(this.secondLevelActive)
            } else {
              this.callback(this.firstLevelActive)
            }
          }
        }
      } else if (data.EventType === socketEvents.error) {
        showNotification(
          'error',
          'Socket',
          _.get(data, 'Result.Message', null),
        )
        this.$root.$emit('popupUpdation', false, true, null)
      }
    },
  },
}
